type ColorValue = {
	string: string;
	int: number;
};

export const avatarColorKeys = [
	"#ffaa00",
	"#0084ff",
	"#ff4800",
	"#00ff91",
	"#00ffc3",
	"#00eeff",
	"#0066ff",
	"#f6ff00",
	"#ffb700",
	"#0ac900",
	"#ff0000",
	"#8c00ff",
	"#002aff",
	"#d900ff",
];

export const colorKeys: Record<string, ColorValue> = {
	dev: {
		string: "#00ff00",
		int: 0x00ff00,
	},

	admin: {
		string: "#dd316c",
		int: 0xdd316c,
	},
	adminTransparent: {
		string: "#dd316c80",
		int: 0xdd316c80,
	},

	primary: {
		string: "#000000",
		int: 0x000000,
	},
	primaryTransparent: {
		string: "#00000030",
		int: 0x00000030,
	},

	secondary: {
		string: "#ffffff",
		int: 0xffffff,
	},
	secondaryTransparent: {
		string: "#ffffff80",
		int: 0xffffff80,
	},

	accent: {
		string: "#fff200",
		int: 0xfff200,
	},
	accentTransparent: {
		string: "#fff20080",
		int: 0xfff20080,
	},

	transparent: {
		string: "#00000000",
		int: 0x00000000,
	},
} as const;
